import React from 'react';
import { Gift } from 'lucide-react';
const BONUSES = [{
  title: 'BONUS 1: Los 10 usos más simples de la IA',
  image: 'https://cdn.magicpatterns.com/uploads/htsAitSi91QFnFq9E68Ebt/ChatGPT_Image_27_dic_2025,_04_18_31.png',
  description: 'Lista práctica 100% aplicable. Funciona ¡SIN TECNICISMOS!'
}, {
  title: 'BONUS 2: Guía rápida de herramientas',
  image: 'https://cdn.magicpatterns.com/uploads/vLy6C8cNSrLWFFVtXwxZgU/ChatGPT_Image_27_dic_2025,_04_21_54.png',
  description: 'Qué herramientas usar y cuáles NO para no perder tiempo.'
}, {
  title: 'BONUS 3: Plan de acción 7 DÍAS',
  image: 'https://cdn.magicpatterns.com/uploads/gXsYnczURDzFk3jNEfwSiQ/ChatGPT_Image_27_dic_2025,_04_21_57.png',
  description: 'Cómo empezar sin dejar tu trabajo. Paso a paso diario.'
}, {
  title: 'BONUS 4: Errores comunes',
  image: 'https://cdn.magicpatterns.com/uploads/mNTnb2AKdWiKmseFRmezc2/ChatGPT_Image_27_dic_2025,_04_26_48.png',
  description: 'Lo que te hace perder tiempo y dinero (y cómo evitarlo).'
}];
export function BonusSection() {
  return <section className="py-16 px-4 relative overflow-hidden" data-id="element-1">
      <div className="absolute inset-0 bg-gradient-to-br from-slate-950 via-yellow-950/20 to-black" data-id="element-2" />
      <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/dark-matter.png')] opacity-30" data-id="element-3" />
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_50%,_rgba(234,179,8,0.1),_transparent_70%)]" data-id="element-4" />
      <div className="absolute top-10 right-10 w-64 h-64 border border-yellow-500/10 rounded-full" data-id="element-5" />
      <div className="absolute bottom-10 left-10 w-48 h-48 border border-yellow-500/10 rounded-full" data-id="element-6" />

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-7">
        <div className="text-center mb-12" data-id="element-8">
          <span className="inline-block px-4 py-1 bg-yellow-500/20 text-yellow-400 border border-yellow-500/50 rounded-full text-sm font-bold mb-4 animate-pulse" data-id="element-9">
            OFERTA LIMITADA
          </span>
          <h2 className="font-display text-5xl md:text-6xl font-bold text-white mb-4 tracking-wide" data-id="element-10">
            <span className="text-yellow-400" data-id="element-11">BONUS GRATIS</span> POR HOY
          </h2>
          <p className="text-xl text-slate-300 max-w-2xl mx-auto" data-id="element-12">
            Llevate todo este material complementario sin costo adicional al
            ordenar ahora.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-13">
          {BONUSES.map((bonus, index) => <div key={index} className="group relative bg-gradient-to-br from-slate-900/80 to-slate-950/80 backdrop-blur-sm rounded-xl overflow-hidden border border-yellow-500/20 hover:border-yellow-500/50 transition-all duration-300 hover:shadow-[0_0_30px_rgba(234,179,8,0.15)]" data-id="element-14">
              <div className="absolute top-4 right-4 z-20 bg-gradient-to-r from-yellow-500 to-yellow-600 text-slate-900 font-bold px-3 py-1 rounded shadow-lg flex items-center gap-2" data-id="element-15">
                <Gift className="w-4 h-4" data-id="element-16" />
                GRATIS
              </div>
              <div className="relative overflow-hidden flex items-center justify-center bg-slate-800/50 p-6" data-id="element-17">
                <img src={bonus.image} alt={bonus.title} className="w-full max-w-[280px] h-auto object-contain transform group-hover:scale-105 transition-transform duration-500" data-id="element-18" />
              </div>
              <div className="p-6 text-center" data-id="element-19">
                <h3 className="text-xl font-bold text-white mb-2" data-id="element-20">
                  {bonus.title}
                </h3>
                <p className="text-yellow-200/80 text-sm" data-id="element-21">
                  {bonus.description}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}